import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { PageHeader } from 'src/components/common/page-header';
import { UnauthorizedPage } from 'src/components/common/unauthorized';
import LmsCurriculumForm from 'src/components/lms/curriculums/form';
import { Actions, AppArea, Subjects } from 'src/graphql/generated/graphql';
import { Can } from 'src/utils/can';

export const LmsCurriculumFormPage = () => {
  const { t } = useTranslation();
  const { id } = useParams();

  const title = id
    ? t('lms.curriculum.title-edit', 'Edit Curriculum')
    : t('lms.curriculum.title-add-new', 'Add New Curriculum');

  const breadCrumbsProps = {
    items: [{ label: title }],
  };

  return (
    <>
      <Can I={Actions.Write} a={Subjects.Curriculums} appArea={AppArea.Lms}>
        <PageHeader title={title} breadcrumbs={breadCrumbsProps} />
        <LmsCurriculumForm id={id} />
      </Can>
      <Can not I={Actions.Write} a={Subjects.Curriculums} appArea={AppArea.Lms}>
        <UnauthorizedPage />
      </Can>
    </>
  );
};
